import { useMemo } from "react";
import {
  PublicJobDepartmentResponse,
  useGetCareerPageJobs,
} from "../../../../../api-docs";
import { JobFilterItem } from "../item";
import { useQueryParam, ObjectParam, withDefault } from "next-query-params";
import _, { orderBy } from "lodash";
import useRouterVariable from "../../../../../../components/utils/useRouterVariable";

export const useDepartmentFilterState = () => {
  const [selected, setSelected] = useQueryParam(
    "departments",
    withDefault(ObjectParam, {})
  );
  const selectedKeys = useMemo(() => {
    const obj = {};
    Object.keys(selected).forEach((key) => {
      obj[key] = selected[key] === "t" ? true : false;
    });
    return obj;
  }, [selected]);
  const toggle = (key: string) => {
    const copy = {
      ...selected,
    };
    if (copy[key]) {
      delete copy[key];
    } else {
      copy[key] = "t";
    }
    setSelected(copy, "replaceIn");
  };
  const clear = () => {
    setSelected({}, "replaceIn");
  };

  return {
    selected: selectedKeys,
    toggle,
    clear,
  };
};

export const DepartmentsFilterItem = () => {
  const org = useRouterVariable("org", (o) => o as string);
  const jobOverviews = useGetCareerPageJobs(org as string);

  const options = useMemo(() => {
    const departments = _.uniqBy<PublicJobDepartmentResponse>(
      jobOverviews?.data?.flatMap((x) => x.departments),
      "name"
    );
    return orderBy(
      (departments ?? []).map(({ departmentId, name }) => ({
        id: departmentId,
        label: name,
        value: departmentId.toString(),
      })),
      (i) => i.label.toLocaleUpperCase()
    );
  }, [jobOverviews.data]);

  const state = useDepartmentFilterState();

  if (jobOverviews.isLoading) {
    return null;
  }
  if (jobOverviews.isError) {
    return null;
  }

  return (
    <JobFilterItem
      items={options}
      title="Departments"
      type="departments"
      onItemClick={(item) => state.toggle(item.value)}
      count={Object.keys(state.selected).length}
      selectedItems={state.selected}
    />
  );
};
